import { Registry } from '@/entities/Registry'
import api from '@/services/api'
import { format } from 'date-fns'

import {
  IPreference,
  ISpecialities,
  IAvailabilityCalls,
} from './register-types-services'

export const registerProfessional = async (
  data: Registry,
  token?: string,
): Promise<boolean> => {
  const requestData = {
    nome: data.name,
    sobrenome: data.lastName,
    email: data.email,
    telefone: data.celular,
    senha: data.password,
    cpf: data.cpf,
    dataNascimento: format(new Date(data.birthday), 'dd/MM/yyyy'),
    numeroCrm: data.crm,
    ufCrm: data.ufCrm,
    sexo: data.sex,
    especialidade: data.speciality,
    outraEspecialidade: data.anotherSpeciality,
    idPreferenciaAtendimento: data.preferenceForAttendance,
    // cidade: data.city, // needs to add field
    possuiBirdId: data.hasBirdId,
    possuiCnpj: data.hasCnpj,
    cidadeNascimento: data.hometown,
    disponibilidadeAtendimento: data.serviceAvailability.map(
      item => item.value,
    ),
  }

  const response = await api.post(
    'captacao-profissionais/profissionais',
    requestData,
    {
      headers: {
        captcha: token,
      },
    },
  )

  return response?.data?.object
}

export const getSpecialities = async (): Promise<ISpecialities[]> => {
  const response = await api.get('/captacao-profissionais/especialidades')

  return response.data.object || []
}
export const getPreferences = async (): Promise<IPreference[]> => {
  const response = await api.get(
    'captacao-profissionais/preferencias-atendimento',
  )

  return response.data.object || []
}
export const getAvailabilityCalls = async (): Promise<IAvailabilityCalls[]> => {
  const response = await api.get('captacao-profissionais/horarios-disponiveis')

  return response.data.object || []
}
